import React from "react";
import FieldString from "../../string/string";
import FieldConfig from "../../../proto/field-config";
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups";
import FieldUrl_ViewSmall from "./render/view-small";
import FieldUrl_View from "./render/view";
import FieldUrl_ManagementPreview from "./render/management-preview";
import FieldUrl_InlineEditable from "./render/inline-editable";
import FieldUrl_Editable from "./render/editable/editable";

export default class FieldUrl extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Url";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Web link field"
        this.icon               = 'i5-globe';

        this.components.ValueIcon   = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>

        this.renderComponents.view              = FieldUrl_View
        this.renderComponents.viewSmall         = FieldUrl_ViewSmall

        this.renderComponents.inlineEditable    = FieldUrl_InlineEditable

        this.renderComponents.managementPreview = FieldUrl_ManagementPreview

        this.renderComponents.editable          = FieldUrl_Editable

    }

}
